export const persistTheme = (theme) => {
  localStorage.setItem('theme', theme)
}

export const getDefaultTheme = () => {
  return localStorage.getItem('theme')
}
